
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { ModalButtonOptions } from '@/common/enums/ModalButtonOptions.enum';

@Options({
	name: 'Modal',
	components: {},
	emits: ['confirm', 'cancel'],
})
export default class KioskModal extends Vue {
	@Prop() modalTitle!: string;
	@Prop() buttonOptions!: ModalButtonOptions;
	ModalButtonOptions = ModalButtonOptions;
}
